/* ============
 * Actions for the services
 * ============
 *
 * The actions that are available on the
 * services.
 */

import { SET_OPT_OUT, SET_TOP_MENU } from './mutation-types';

export default {
  setOptOut,
  initOptOut,
  setTopMenu,
  hideMiniMap,
  showMiniMap,
};

function initOptOut({ rootGetters, commit }) {
  const value = rootGetters['localStorage/getItem'](SET_OPT_OUT) || false;

  commit(SET_OPT_OUT, value);
}

function setOptOut({ commit }, value = false) {
  commit('localStorage/setItem', { key: SET_OPT_OUT, value }, { root: true });
  commit(SET_OPT_OUT, value);
}

function setTopMenu({ commit }, value) {
  commit(SET_TOP_MENU, value);
}

function showMiniMap({ commit }) {
  commit('showMiniMap');
}

function hideMiniMap({ commit }) {
  commit('hideMiniMap');
}
